/** Column fields that pin to the right edge (action icon columns). */
const RIGHT_PINNED_FIELDS = new Set(["actions", "delete", "restore"]);

export type PinnedColumnsInput =
	| string[]
	| { left?: string[]; right?: string[] }
	| null
	| undefined;

export type NormalizedPinnedColumns = {
	left: string[];
	right: string[];
};

function collectRightPinnedFields(fields: string[]): string[] {
	const right: string[] = [];
	for (const field of fields) {
		if (RIGHT_PINNED_FIELDS.has(field) && !right.includes(field)) {
			right.push(field);
		}
	}
	return right;
}

/**
 * Normalize pinned-column config for MUI X. Only action columns pin on the right;
 * left pinning is never applied (checkbox / name / status columns scroll with the grid).
 */
export function normalizePinnedColumns(
	pinnedColumns: PinnedColumnsInput,
): NormalizedPinnedColumns | undefined {
	if (pinnedColumns == null) {
		return undefined;
	}

	let right: string[] = [];

	if (Array.isArray(pinnedColumns)) {
		if (pinnedColumns.length === 0) {
			return undefined;
		}
		right = collectRightPinnedFields(pinnedColumns);
	} else {
		// Legacy object configs may list left pins — ignore them; right pins only.
		right = collectRightPinnedFields([
			...(pinnedColumns.left ?? []),
			...(pinnedColumns.right ?? []),
		]);
	}

	if (right.length === 0) {
		return undefined;
	}
	return { left: [], right };
}

export function isColumnPinningEnabled(pinnedColumns: PinnedColumnsInput): boolean {
	const normalized = normalizePinnedColumns(pinnedColumns);
	return normalized != null;
}
